import { createContext, ReactNode, useContext } from "react";

import { useFilterQuoteTransport } from "./filter-quote-transport.hook";

const FilterQuoteTransportContext = createContext(
  {} as ReturnType<typeof useFilterQuoteTransport>
);
export function useFilterQuoteTransportContext() {
  return useContext(FilterQuoteTransportContext);
}

interface FilterQuoteTransportProviderProps {
  children: ReactNode;
}
export function FilterQuoteTransportProvider({
  children,
}: FilterQuoteTransportProviderProps) {
  return (
    <FilterQuoteTransportContext.Provider value={useFilterQuoteTransport()}>
      {children}
    </FilterQuoteTransportContext.Provider>
  );
}